import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'coloredPercent'
})
export class ColoredPercentPipe implements PipeTransform {

  transform(value: any, precision: number = 0, defaultInvalidValue: any = ''): any {
    let input = parseFloat(value);

    if (isNaN(input)) {
      return defaultInvalidValue;
    }

    let percent = (input * 100.0).toFixed(precision).replace('.', ',') + '%';

    let html = '';

    if (input >= 0) {
      html = '<i class="colored-percent colored-percent-positive">' + percent + '</i>';
    } else {
      html = '<i class="colored-percent colored-percent-negative">' + percent + '</i>';
    }

    return html;
  }

}
